var _defs, _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakScheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#ed0000;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.27,22.61c-1.17-.38-2.34-.22-3.31.41h0c.03-.66.05-1.34.05-2.02,0-.25-.2-.45-.45-.45H6.29c-.25,0-.45.2-.45.45,0,4.78.81,8.94,2.4,12.36,1.15,2.48,2.74,4.55,4.63,6.06h17.13c1.07-.86,2.04-1.89,2.89-3.07l6.62-3.32c1.86-.83,3.22-2.57,3.64-4.65.07-.34.11-.66.11-.94v-.4c.05-2.04-1.15-3.82-2.97-4.42ZM41.75,27v.4c-.01.2-.04.43-.09.68-.33,1.61-1.37,2.95-2.79,3.58-.01,0-.02,0-.03.01l-4.5,2.26s0,0,0,0c.1-.19.19-.38.28-.57,1.1-2.36,1.82-5.07,2.16-8.1t0,0c.09-.05.17-.12.23-.21.68-.97,1.72-1.35,2.79-1,.92.3,1.98,1.25,1.95,2.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61,40.9c0,1.48,1.2,2.68,2.68,2.68h24.18c1.48,0,2.68-1.2,2.68-2.68H6.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,38.71c-.38,0-.74-.21-.91-.57-.24-.5-.03-1.11.47-1.36l9.33-4.52s.02,0,.03-.01c1.48-.66,2.56-2.05,2.9-3.73.05-.26.08-.5.09-.7v-.43c.05-1.73-1.03-2.69-1.96-3-1.06-.35-2.11.03-2.79,1.01-.32.46-.95.57-1.41.25-.46-.32-.57-.95-.25-1.41,1.19-1.7,3.18-2.39,5.08-1.77,2.06.67,3.41,2.67,3.36,4.97v.43c-.02.32-.06.68-.13,1.05-.47,2.31-1.98,4.25-4.05,5.17l-9.31,4.51c-.14.07-.29.1-.44.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.92,19.89c-.19,0-.38-.06-.54-.19-.36-.3-.42-.84-.12-1.2.09-.11.18-.21.27-.31.35-.39.54-.6.54-1.12s-.19-.73-.54-1.12c-.41-.46-.98-1.09-.98-2.26s.57-1.8.98-2.26c.16-.17.29-.32.38-.48.24-.4.76-.54,1.17-.3.4.24.54.76.3,1.17-.18.3-.4.54-.58.75-.35.39-.54.6-.54,1.12s.19.73.54,1.12c.41.46.98,1.09.98,2.26s-.57,1.8-.98,2.26c-.08.09-.15.17-.22.25-.17.21-.41.31-.66.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.57,14.26c-.19,0-.38-.06-.54-.19-.36-.3-.42-.84-.12-1.2.09-.11.18-.21.27-.31.35-.39.54-.6.54-1.12s-.19-.73-.54-1.12c-.41-.46-.98-1.09-.98-2.26s.57-1.8.98-2.26c.16-.17.29-.32.38-.48.24-.4.76-.54,1.17-.3.4.24.54.76.3,1.17-.18.3-.4.54-.58.75-.35.39-.54.6-.54,1.12s.19.73.54,1.12c.41.46.98,1.09.98,2.26s-.57,1.8-.98,2.26c-.08.09-.15.17-.22.25-.17.21-.41.31-.66.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakScheduler);
export default __webpack_public_path__ + "static/media/break-scheduler.27872ff2844e863a1a1c66248ce0c56b.svg";
export { ForwardRef as ReactComponent };